(function() {
	'use strict';

	angular.module('quantixApp').factory('ClientListService',
			ClientListService);

	ClientListService.$inject = [ '$resource','$http','$q' ];

	function ClientListService($resource,$http,$q) {

		
		var _getClientList = function(searchText) {

			var deferred = $q.defer();
			var url = 'api/clientList/getClientList';

			$http.post(url,searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		var _getClientDetails = function(clientCode) {

			var deferred = $q.defer();
			var url = 'api/clientDetails/getClientDetails';

			$http.post(url,clientCode).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		var _getUserMovementList = function(clientCode) {

			var deferred = $q.defer();
			var url = 'api/clientDetails/getUserMovementList';

			$http.post(url,clientCode).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		var _getDataProductList = function() {

			var deferred = $q.defer();
			var url = 'api/clientDetails/getDataProductList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		var _getRissProductNameList = function() {

			var deferred = $q.defer();
			var url = 'api/clientDetails/getRissProductName';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		var _getWithdrawnList = function(searchData) {

			var deferred = $q.defer();
			var url = 'api/adminScreen/getWithdrawnData';

			$http.post(url,searchData).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		//User Manual
		
		var _getUserManualList = function() {

			var deferred = $q.defer();
			var url = 'api/adminScreen/getUserManualData';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
		
		
		
		
	
		return {
			getClientList : _getClientList,
			getClientDetails : _getClientDetails,
			getUserMovementList : _getUserMovementList,
			getDataProductList : _getDataProductList,
			getRissProductNameList : _getRissProductNameList,
			getWithdrawnList : _getWithdrawnList,
			getUserManualList: _getUserManualList
			
		};
	}
})();
